import { render, staticRenderFns } from "./form-file.vue?vue&type=template&id=169bea97&scoped=true"
import script from "./form-file.ts?vue&type=script&lang=ts&external"
export * from "./form-file.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169bea97",
  null
  
)

export default component.exports